import { gql } from '@apollo/client';

export const GetOLCertificateURLForAnonStudentQuery = gql`
    query GetOLCertificateURLForAnonStudent($fullName: String!) {
        getOLCertificateURLForAnonStudent(fullName: $fullName)
    }
`;
